import request from '@/router/axios';

const add = params => request({
  url: '/api/mcc-worker/infoequipment/save',
  method: 'post',
  data: {
    ...params,
  },
})

const getList = (current, size, params, deptId) => request({
  url: '/api/mcc-worker/infoequipment/page',
  method: 'get',
  params: {
    ...params,
    current,
    size,
    deptId,
  },
})
const getLatest = (params) => request({
  url: '/api/mcc-worker/infoequipment//getLatest',
  method: 'get',
  params: {
    ...params,
  },
})
// 上传excel
const workerEquipmentImport = (filename, file) => {
  const formData = new FormData()
  console.log(formData, 'formdata')
  formData.append(filename, file)
  return request({
    url: '/api/mcc-worker/infoequipment/import',
    method: 'post',
    data: formData,
  })
}
const update = params => request({
  url: '/api/mcc-worker/infoequipment/update',
  method: 'post',
  data: params,
})
const getCategoryHistory = (params) => request({
  url: '/api/mcc-worker/infoequipment/getHistory',
  method: 'get',
  params: {
    ...params,

  },
})

export default {
  getList,
  update,
  add,
  workerEquipmentImport,
  getLatest,
  getCategoryHistory
}
